export enum MarketingDataParam {
  PIXEL_ID = "pixelid",
  FBCL_ID = "fbclid",
  CODE = "code",
  C_ID = "cid",
  SUB_ID = "subid",
  TT_PIXEL_ID = "ttpixelid",
  TTCL_ID = "ttclid",
  KW_PIXEL_ID = "kwpixelid",
  CLICK_ID = "clickid",
  URL = "url",
  MKT_VERSION = "mktversion",
}

/** The params collected from the landing URL. URL and MKT_VERSION are derived, so they are not here. */
export const MARKETING_DATA_PARAMS: MarketingDataParam[] = [
  MarketingDataParam.PIXEL_ID,
  MarketingDataParam.FBCL_ID,
  MarketingDataParam.CODE,
  MarketingDataParam.C_ID,
  MarketingDataParam.SUB_ID,
  MarketingDataParam.TT_PIXEL_ID,
  MarketingDataParam.TTCL_ID,
  MarketingDataParam.KW_PIXEL_ID,
  MarketingDataParam.CLICK_ID,
];

export interface MarketingData {
  [MarketingDataParam.PIXEL_ID]: string;
  [MarketingDataParam.FBCL_ID]: string;
  [MarketingDataParam.CODE]: string;
  [MarketingDataParam.C_ID]: string;
  [MarketingDataParam.SUB_ID]: string;
  [MarketingDataParam.TT_PIXEL_ID]: string;
  [MarketingDataParam.TTCL_ID]: string;
  [MarketingDataParam.KW_PIXEL_ID]: string;
  [MarketingDataParam.CLICK_ID]: string;
  [MarketingDataParam.URL]: string;
  [MarketingDataParam.MKT_VERSION]: string;
}
